// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutShippingAddressesStyles } from "@guestsupply/Overrides/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

checkoutShippingAddressesStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 135px;
        row-gap: 24px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};
checkoutShippingAddressesStyles.addressContainer = {
    css: css`
        ${({ currentUserIsGuest }: any) => (currentUserIsGuest ? "width:50%;" : "width: 301px;")}
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
checkoutShippingAddressesStyles.loadingWrapper = {
    css: css`
        display: flex;
        height: 450px;
        justify-content: center;
        align-items: center;
    `,
};
checkoutShippingAddressesStyles.addressItem = { width: 12 };
checkoutShippingAddressesStyles.shippingAddressGridItem = { width: [12, 12, 12, 6, 6] };
checkoutShippingAddressesStyles.billingAddressGridItem = { width: [12, 12, 12, 6, 6] };
